import '@babel/polyfill'
import Vue from 'vue'
import startAccount from '@/views/startAccount/App.vue'
import '@/utils/remH5.js'
import VantComponents from '@/config/vant.components.js'
import Components from '@/components/index.js'
import store from '@/store/startAccount'
import router from '@/router/startAccount'
import qs from 'qs'
import '@/assets/css/common.less'
import { i18n, vantLocales } from '@/i18n/startAccount/index.js'
import { isWeiXin, isQQBrowser, isDingtalk, isHLApp, isTHSApp, toggleDebug } from '@/utils'
import './init.js'
import { initThsI18nBury } from './init.js'
import '@/utils/registerSentry.js'
import { applyDarkMode } from '@/utils/useDark'

// error handler
import { initErrorLoggerHandler } from '@/utils/logService'
initErrorLoggerHandler()

const { VUE_APP_ENV = 'sit' } = process.env
if (VUE_APP_ENV !== 'prod') {
    toggleDebug(true)
}
// vant-ui组件国际化
vantLocales(i18n.locale)
// import { toggleDebug } from '@/utils'

VantComponents(Vue)
Components(Vue)
Vue.config.productionTip = false

new Vue({
    i18n,
    router,
    store,
    beforeCreate() {
        applyDarkMode()
    },
    async created() {
        await initThsI18nBury()
        this.$thsI18nTrack({ id: 'ht_ovs_kaihu_enter_90028', action: 'start' })
    },
    render: h => h(startAccount),
}).$mount('#app')

router.beforeResolve((to, form, next) => {
    let searchQuery = {}
    if (window.location.search) {
        searchQuery = qs.parse(window.location.search?.split('?')[1])
    }
    const fullQuery = { ...searchQuery, ...to.query }

    const wtToken = fullQuery.wtToken || ''
    const userName = fullQuery.name || ''
    const sub = fullQuery.sub || ''
    let nav = fullQuery.nav || ''
    //在微信、QQ、钉钉中打开，不显示导航条
    nav = isWeiXin() || isQQBrowser() || isDingtalk() || isHLApp() || isTHSApp() ? '0' : nav

    if (wtToken) {
        store.dispatch('user/setWTToken', wtToken)
    }
    if (sub) {
        store.dispatch('user/setSubAccountId', sub)
    }
    if (userName) {
        store.dispatch('user/setWTuserName', userName)
    }
    if (nav) {
        const navValue = nav == '0' ? 'hide' : 'show'
        store.dispatch('app/setNav', navValue)
    }

    // 共享登录token
    const { session, rndKey, uin } = fullQuery
    if (session && rndKey && uin) {
        localStorage.setItem('session', session)
        localStorage.setItem('rndKey', rndKey)
        localStorage.setItem('uin', uin)
    }
    next()
})
